import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLocation, useHistory } from 'react-router-dom';
import useConfigs from '../hooks/useConfigs';
import { fetchListaConfiguracion } from '../services/parameter.service';

const ServicioDetalle = () => {
  window.scroll(0, 0);
  const { state } = useLocation();
  const { fontSizeMultiplier } = useConfigs();
  const history = useHistory();

  const [servicio, setServicio] = useState({});
  const [laboratorioUrl, setLaboratorioUrl] = useState(null);
  const [showIframe, setShowIframe] = useState(false);

  useEffect(() => {
    if (!state) return;

    setServicio(state);
  }, [state]);

  useEffect(() => {
    if (Object.entries(servicio).length === 0 && !state) {
      history.push('/services');
    }
  }, [history, servicio, state]);

  const bodyHTML = servicio && servicio.texto_adicional;

  const nomOpcion = servicio?.nombreOpcion?.includes('Laboratorio');

  const handleClick = () => setShowIframe(!showIframe);

  const getUrl = async () => {
    try {
      const response = await fetchListaConfiguracion({
        key: 'URL_LABORATORIOS',
      });

      setLaboratorioUrl(response.data.list[0]?.value);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUrl();
  }, []);

  return (
    <>
      {nomOpcion && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '3rem 0',
          }}
        >
          <CustomButton onClick={() => handleClick()}>
            Descargar Resultados
          </CustomButton>
        </div>
      )}

      {showIframe && (
        <ContaineriFrame id='contBodyHTML'>
          <div className='iframe-container'>
            <iframe
              src={laboratorioUrl}
              title='Doctor Famedic'
              frameborder='0'
            ></iframe>
          </div>
        </ContaineriFrame>
      )}
      {servicio.texto_adicional ? (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <DivContainer id='contBodyHTML'>
              <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
            </DivContainer>
          </div>
        </>
      ) : (
        <Container fontsizemultiplier={fontSizeMultiplier}>
          <div className='hero'>
            <img src={servicio.imagen} alt='Hero' />
          </div>

          <div className='info-container'>
            <h1>{servicio.nombreOpcion}</h1>

            <p>{servicio.texto}</p>
          </div>
        </Container>
      )}
    </>
  );
};

export default ServicioDetalle;

const Container = styled.div`
  margin: 0;
  padding: 0;

  .hero {
    max-height: 40vh;

    img {
      width: 100%;
      max-height: 40vh;
      object-fit: cover;
    }
  }

  .info-container {
    min-height: 60vh;
  }

  h1 {
    font-size: ${(props) => 60 * props.fontsizemultiplier};
    padding: 2rem 10%;
    margin-bottom: 0;
  }

  p {
    font-size: ${(props) => 20 * props.fontsizemultiplier};
    padding: 2rem 10%;
  }
`;

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;

  p {
    text-align: center;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;

const CustomButton = styled.a`
  background-color: #04aaaa;
  color: #fff;
  font-size: ${(props) => 16 * props.fontsizemultiplier};
  border: 1px solid;
  padding: 5rem 10rem;
  margin-bottom: 2rem;
  border-radius: 100px;
  font-weight: 700;
  font-size: 20px;
  letter-spacing: 1px;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  transition: all 0.3s;

  @media (max-width: 1150px) {
    margin-top: 2rem;
  }

  &:hover,
  &:focus {
    transform: scale(1.05);
    text-decoration: none;
    filter: brightness(1.1);
    color: #fff;
    letter-spacing: 2px;
  }
`;

const ContaineriFrame = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .iframe-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100% !important;
    height: 100vh !important;

    iframe {
      width: 60% !important;
      height: 100% !important;
      margin: 0 auto;

      @media (max-width: 1000px) {
        width: 70% !important;
      }

      @media (max-width: 800px) {
        width: 100% !important;
      }
    }
  }
`;
